export const getWcLinkFromDeeplink = (link:string): string => {
  const regexResult = link.match(/wc\:[a-zA-z0-9\-]*@[1-2]\?bridge=https(:|%3A)(%2F%2F|:\/\/)[a-zA-Z0-9\.\-\_]*&key=[0-9a-fA-F]*/);
  if (regexResult === null) {
    return null;
  }
  return regexResult[0];
};
